/* eslint-disable */
import { bus } from '../../main';
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  mapGetters
} from 'vuex';
import { VueEditor } from "vue2-editor";
export default {
  name: 'create-course-producer',
  components: {
    VueEditor
  },
  props: [],
  data() {
    return {
      submitted: false,
      name: '',
      course:'',
      courseId:'',
      producerListDetails:'',
      removeProducerId:'',
      is_producer:'',
      gender:''
    }
  },
  computed: {
    ...mapGetters([
      'getAuthorDataState',
    ]),
    geProducerListByIdFun() {
      this.$store.dispatch('getAuhtorsFun', {
        id: this.$route.params.courseId
      }).then((res) => {
        this.producerListDetails = this.$store.getters.getAuthorDataState.data
      }).catch((err) => {})
    },
  },
  mounted() {
    this.geProducerListByIdFun
    this.courseId = this.$route.params.courseId
  },
  methods: {
    geProducerListByIdFunAgain() {
      this.$store.dispatch('getAuhtorsFun', {
        id: this.$route.params.courseId
      }).then((res) => {
        this.producerListDetails = this.$store.getters.getAuthorDataState.data
      }).catch((err) => {})
    },
   createAuthorNamConfirmation(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
              name: this.name,
              is_producer:true,
              gender: 'F',
              course:this.$route.params.courseId
          }
          this.$store.dispatch('createAuhtorFun', data)
            .then((res) => {
              this.name = '',
              toast.success(res.data.msg);
              this.$validator.reset();
              this.geProducerListByIdFunAgain()
            })
            .catch((err) => { })
          return
        }
      });
    },
    removeAuthor(id) {
      $('#removProModalAgain').modal();
      this.removeProducerId = id
    },
    RemoveProConfirmationagain(){
      this.$store.dispatch('removAuthorFun', {
        id: this.removeProducerId
      }).then((res) => {
        this.geProducerListByIdFunAgain()
      }).catch((err) => {})
    }
  }
}